export function changeUrl(newUrl, title) {
    if(window.location.href !== newUrl) {
        window.history.pushState({}, title, newUrl);
    }
}

export function redirect(newUrl) {
    window.location.href = newUrl;
}
